import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {NineToFive} from "../../NineToFive";
import {gsap} from "gsap";
import {NineToFiveXWaysSymbol} from "../../reels/symbols/XWaysSymbol";

/**
 * Created by jonas on 2022-09-02.
 */
export class FreeSpinOvertime implements SimplePresentation {

    name:string = "FreeSpinOvertime";

    constructor() {
    }

    shouldRun():boolean {
        return !NineToFive.model.gameData.brokeTheBank && this.getOTSymbols().length > 0;
    }

    private getOTSymbols():NineToFiveXWaysSymbol[] {
        return <NineToFiveXWaysSymbol[]>NineToFive.baseGameReelView.getAllSymbols().filter((sym) => sym.symbolName == "OT");
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline({
            onComplete: () => {
                controller.finish();
                controller.setSkipCallback();
            }
        })
            .add(() => {
                controller.setSkipCallback(() => {
                    //tl.seek("End", false)
                });
            })
            .add(this.getOTSymbols().map((sym) => sym.getWinAnimationBased()))
            .add(() => {NineToFive.soundPlayer.playSound("overTimeActivation")}, '<')
            .add(NineToFive.transitionScreen.showOvertime(this.getOTSymbols().length), '<1.05')
            .add(() => {NineToFive.soundPlayer.playSound("overTimeBigOverlay")}, '<')
            .add(() => {
                NineToFive.keypadPlugin.setZeroBetSpinCounter(NineToFive.model.data.freespinsLeft);
            }, '<')
            .addLabel("End")
            //.add(() => {}, '>0.3');
    }
}
